import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Upload an image File to the backend.
 * Backend stores it on disk under /app/frontend/public/uploads/<uuid>.<ext>
 * and returns a relative URL like "/uploads/<uuid>.<ext>" that resolves
 * directly via the frontend static folder.
 *
 * @param {File} file        – the File object from <input type="file">
 * @param {Object} headers   – auth headers (e.g. from getAuthHeaders())
 * @returns {Promise<string>} the URL string to store in DB
 */
export async function uploadImage(file, headers = {}) {
  if (!file) throw new Error('No file provided');

  const fd = new FormData();
  fd.append('file', file);

  const res = await axios.post(`${API}/upload`, fd, {
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(headers.headers || headers),
    },
  });

  if (!res.data?.url) {
    throw new Error('Upload response missing URL');
  }
  return res.data.url;
}
